// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { SurveyInfoResponseDTO } from "../api/backend-openapi";
import { SURVEY_WORKFLOW_STATUS } from "./Constant";
import moment, { now } from "moment";

export const getStatusSurveyFrom = (survey: SurveyInfoResponseDTO): string => {
  if (
    SURVEY_WORKFLOW_STATUS[survey.status] ===
      SURVEY_WORKFLOW_STATUS.PUBLISHED &&
    survey.scheduledAvailabilityDate &&
    moment(survey.scheduledAvailabilityDate).isAfter(now())
  ) {
    return "WAITINGFORPUBLICATION";
  } else if (
    SURVEY_WORKFLOW_STATUS[survey.status] ===
      SURVEY_WORKFLOW_STATUS.PUBLISHED &&
    survey.scheduledVoteCloseDate &&
    moment(now()).isAfter(survey.scheduledVoteCloseDate)
  ) {
    return "VOTECLOSED";
  }
  return survey.status;
};

export const getStatusResponseSurveyFrom = (
  survey: SurveyInfoResponseDTO
): string => {
  if (
    moment(now()).isBefore(survey.scheduledAvailabilityEndDate) ||
    survey.scheduledAvailabilityEndDate === null ||
    survey.scheduledAvailabilityEndDate === undefined
  ) {
    if (
      SURVEY_WORKFLOW_STATUS[survey.status] ===
        SURVEY_WORKFLOW_STATUS.PUBLISHED &&
      moment(now()).isAfter(survey.scheduledResultAvailabilityDate) &&
      (moment(now()).isBefore(survey.scheduledVoteCloseDate) ||
        survey.scheduledVoteCloseDate === null ||
        survey.scheduledVoteCloseDate === undefined)
    ) {
      return "LIVE";
    } else if (
      SURVEY_WORKFLOW_STATUS[survey.status] ===
        SURVEY_WORKFLOW_STATUS.PUBLISHED &&
      moment(now()).isAfter(survey.scheduledResultAvailabilityDate)
    ) {
      return "FINAL";
    }
  }
  return "";
};

export const getPublicationDateSurveyFrom = (
  survey: SurveyInfoResponseDTO
): Date | undefined => {
  if (survey.publicationDate !== undefined && survey.publicationDate !== null) {
    return survey.scheduledAvailabilityDate
      ? survey.scheduledAvailabilityDate
      : survey.publicationDate;
  }
  return undefined;
};

export const canBeDeleted = (survey: SurveyInfoResponseDTO): boolean => {
  return (
    survey.publicationDate === undefined || survey.publicationDate === null
  );
};
